import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import entityComposition from '../../common/classes/entityComposition';
import { hasSummaryPermissions } from '../../common/classes/permissions';
import routeHelper from '../../common/classes/routeHelper';
import SummariesListPanel from './summariesListPanel';
import Summary from './summary';
class Summaries extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: null
    };
  }
  componentDidMount() {
    const {
      location,
      summaryActions,
      summary,
      jobSelectSummary,
      jobSelectSummaryActions
    } = this.props;
    const {
      selected
    } = this.state;
    // Redirect and post authorization error message if permissions insufficient
    routeHelper.handleViewRedirect(hasSummaryPermissions(), location);
    summaryActions.serverIndex(summary.indexQuery);
    jobSelectSummaryActions.serverIndex(jobSelectSummary.indexQuery);
    if (summary.list && !selected) {
      this.setState({
        selected: summary.list[0]
      });
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      selected: stateSelected
    } = this.state;
    const selectedSummaryID = nextProps.match.params.section;
    if (nextProps.summary.list) {
      if (!selectedSummaryID) {
        // select the first summary by default
        this.setState({
          selected: nextProps.summary.list[0]
        });
      } else {
        // load the summary id from the URL into state
        const filteredList = nextProps.summary.list.filter(summary => summary.id === selectedSummaryID);
        if (filteredList.length) {
          const selected = filteredList[0];
          if (!stateSelected || selected.id !== stateSelected.id) {
            this.setState({
              selected
            });
          }
        }
      }
    }
  }
  render() {
    const {
      selected
    } = this.state;
    const {
      summary,
      match,
      jobSelectSummary
    } = this.props;
    const currentSummary = selected || {
      name: ''
    };
    return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(SummariesListPanel, {
      summariesList: summary.list,
      section: match.params.section
    })), /*#__PURE__*/React.createElement(Col, {
      sm: 9
    }, /*#__PURE__*/React.createElement(Summary, {
      key: currentSummary.id,
      jobs: jobSelectSummary.list,
      selectedSummary: currentSummary
    }))));
  }
}
Summaries.propTypes = {
  location: PropTypes.shape({}).isRequired,
  // from the router
  match: PropTypes.shape({
    params: PropTypes.shape({
      section: PropTypes.string
    })
  }).isRequired,
  summary: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  summaryActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  jobSelectSummaryActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  jobSelectSummary: PropTypes.shape({
    list: PropTypes.arrayOf(PropTypes.shape({})),
    indexQuery: PropTypes.shape({})
  }).isRequired
};
export { Summaries as TestSummaries };
export default entityComposition(Summaries, ['summary', 'jobSelectSummary'], {});